import React from 'react';

import { NotificationsProvider } from '@adsk/alloy-react-notification';
import { AnalyticsProvider } from '@adsk/nirvana-helpers';

import FolderModal from './FolderModal';
import FolderTree from './FolderTree';
import { getMenuOptions } from '../helpers';
import { MENU_TYPES, PRODUCT_IDS, TOOL_IDS, MENU_ACTIONS } from '../helpers/consts';
import { ServiceProvider, useProject } from '../hooks';
import { FolderPickerRef, FolderPickerProps } from '../types';

const FolderPicker = React.forwardRef<FolderPickerRef, FolderPickerProps>(
  (
    {
      projectId,
      region,
      includePermission = false,
      editable = false,
      flat = false,
      includeServiceProvider = true,
      ...props
    },
    ref
  ) => {
    const project = useProject(projectId);
    const FolderComponent = flat ? FolderTree : FolderModal;
    const folderPickerContentRenderer = () => (
      <NotificationsProvider>
        <AnalyticsProvider>
          <FolderComponent ref={ref} {...props} fullPath={project.folderFullPathEnabled} editable={editable} />
        </AnalyticsProvider>
      </NotificationsProvider>
    );
    return includeServiceProvider ? (
      <ServiceProvider projectId={projectId} includePermission={includePermission || editable} region={region}>
        {folderPickerContentRenderer()}
      </ServiceProvider>
    ) : (
      folderPickerContentRenderer()
    );
  }
);

FolderPicker.displayName = 'FolderPicker';

export default Object.assign(FolderPicker, {
  MENU_ACTIONS,
  MENU_TYPES,
  PRODUCT_IDS,
  TOOL_IDS,
  getDefaultMenuOptions: getMenuOptions
});
